import React from 'react';
import './DemoPage.css';

/**
 * Komponen DemoPage menampilkan halaman demo untuk ebook.
 * Menerima props 'purchaseLink' untuk tautan pembelian.
 */

const DemoPage = ({ purchaseLink, officialStoreLink}) => {
  const handlePurchaseClick = () => {
    if (purchaseLink) {
      window.open(purchaseLink, '_blank');
    } else {
      alert("Tautan pembelian belum tersedia.");
    }
  };

  const handleOfficialStoreLinkClick = () => {
    if (purchaseLink) {
      window.open(officialStoreLink || 'https://lynk.id/rekanata.contractors', '_blank');
    } else {
      alert("Tautan pembelian belum tersedia.");
    }
  };

  return (
    <div className="demo-page-container">
      <div className="demo-page-content">
        {/* Judul Ebook */}
        <h1 className="demo-title">
          Dapatkan Ebook dari Kami
        </h1>

        {/* Deskripsi/Ringkasan Ebook */}
        <p className="demo-summary">
          Temukan solusi dan wawasan berharga melalui panduan lengkap ini. Ebook ini berisi tips praktis, strategi efektif, dan informasi mendalam yang akan membantu Anda mencapai tujuan.
        </p>

        {/* Tombol CTA */}
        <button
          className="purchase-button"
          onClick={handlePurchaseClick}
          disabled={!purchaseLink}
        >
          Dapatkan Versi Lengkap Sekarang
        </button>

        {/* Teks Demo */}
        <p className="demo-disclaimer">Halaman ini adalah versi demo. Beli versi lengkap untuk membuka semua bab dan materi eksklusif. <a onClick={handleOfficialStoreLinkClick}>Klik disini (Atau kunjungi official store kami)</a></p>
      </div>
    </div>
  );
};

export default DemoPage;